import React from "react";
import "./JobDescription.scss";
import { connect } from "react-redux";
import { fetchJob, addLoader, removeLoader } from "../../actions";
import Loader2 from "../loaders/Loader2";
import DescriptionHeader from "./DescriptionHeader";
import DescriptionBody from "./DescriptionBody";
import DescriptionApply from "./DescriptionApply";
import DescriptionFooter from "./DescriptionFooter";

class JobDescription extends React.Component {
  componentDidMount = async () => {
    this.props.addLoader();
    await this.props.fetchJob(this.props.match.params.id);
    this.props.removeLoader();
  };

  render() {
    if (!this.props.selectedJob || this.props.isLoading) {
      return (
        <div className="loader--box">
          <Loader2 />
        </div>
      );
    }
    return (
      <React.Fragment>
        <DescriptionHeader />
        <DescriptionBody />
        <DescriptionApply />
        <DescriptionFooter />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedJob: state.selectedJob,
    isLoading: state.loader.isLoading,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps, { fetchJob, addLoader, removeLoader })(
  JobDescription
);
